import { useState, useEffect } from "react";

export function useWindowDimension() {
    const [dimension, setDimension] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });

    useEffect(() => {
        let isMounted = true; // Flag to track if component is mounted

        const debouncedResizeHandler = debounce(() => {
            if (isMounted) { // Only update if component is still mounted
                setDimension({
                    width: window.innerWidth,
                    height: window.innerHeight,
                });
            }
        }, 100);

        window.addEventListener("resize", debouncedResizeHandler);

        return () => {
            isMounted = false; // Set flag to false when unmounting
            window.removeEventListener("resize", debouncedResizeHandler);
        };
    }, []);
    return dimension;
}

// Updated debounce function to clear timeout on unmount
function debounce(fn: (...args: any[]) => void, ms: number) {
    let timer: NodeJS.Timeout;
    return function (this: any, ...args: any[]) {
        clearTimeout(timer);
        timer = setTimeout(() => {
            fn.apply(this, args);
        }, ms);
    };
}
